import { createContext, useContext, useReducer } from "react";

import { filterReducer } from "../reducer";
import type { UsersTableFilterAction } from "../reducer";
import type { UserTableFilterSchema } from "../schema";

interface FilterContextType {
  filter: UserTableFilterSchema;
  dispatch: React.Dispatch<UsersTableFilterAction>;
}

const UsersTableFilterContext = createContext<FilterContextType | undefined>(
  undefined,
);

export const useUsersTableFilter = () => {
  const context = useContext(UsersTableFilterContext);
  if (!context) {
    throw new Error(
      "useUsersTableFilter must be used within a UsersTableFilterProvider",
    );
  }
  return context;
};

export const UsersTableFilterProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [filter, dispatch] = useReducer(filterReducer<UserTableFilterSchema>, {
    search: undefined,
    status: "EMPTY_VAULE",
  });

  return (
    <UsersTableFilterContext.Provider value={{ filter, dispatch }}>
      {children}
    </UsersTableFilterContext.Provider>
  );
};
